import { render } from "./FileUploadForm.vue?vue&type=template&id=6e1f675b&ts=true"
import script from "./FileUploadForm.vue?vue&type=script&lang=ts"
export * from "./FileUploadForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__